// Premium = the logged-in user's premium_until (from /user/me, in the Redux user store) is
// today or later. ISO "YYYY-MM-DD" strings compare correctly lexicographically.
export const isPremiumUser = (user) =>
  !!user?.premium_until &&
  user.premium_until >= new Date().toISOString().slice(0, 10);
